import { Injectable } from '@angular/core';
import { Admin } from '@wb/core/interfaces/admin';
import { gql, Mutation } from 'apollo-angular';

export interface AdminResponse {
  code: string;
  success: boolean;
  message: string;
  updateAdmin: {
    admin: Admin;
  };
}

export interface DeleteAdminResponse {
  code: string;
  success: boolean;
  message: string;
}

export interface UpdateAdminMutationInput {
  accountUid?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone_number?: string;
  privilege?: number;
  settings?: string;
  agree_terms?: string;
  breadcrumb?: string;
  image?: string;
  image_key?: string;
  status?: string;
  token?: string;
  last_login?: Date;
}

export interface UpdateAdminMutationParams {
  uid: string;
  input: UpdateAdminMutationInput;
}

@Injectable({
  providedIn: 'root',
})
export class UpdateAdminGQL extends Mutation<AdminResponse, UpdateAdminMutationParams> {
  document = gql(`
    mutation updateAdmin(
      $uid: ID!,
      $input: ModelAdminUpdateInput
    ) {
      updateAdmin(uid: $uid, input: $input) {
        code
        success
        message
        admin {
          uid
          first_name
          last_name
          email
          image
          phone_number
          settings
        }
      }
    }
  `);
}

export interface UpdateAdminVersionResponse {
  updateAdminVersion: {
    code: string;
    success: boolean;
    message: string;
    admin: Admin;
  };
}

export interface UpdateAdminVersionMutationInput {
  newUid: string;
  phoneNumber: string;
}

export interface UpdateAdminVersionMutationParams {
  uid: string;
  input: UpdateAdminVersionMutationInput;
}

@Injectable({
  providedIn: 'root',
})
export class UpdateAdminVersionGQL extends Mutation<UpdateAdminVersionResponse, UpdateAdminVersionMutationParams> {
  document = gql(`
    mutation updateAdminVersion(
      $uid: ID!,
      $input: ModelAdminVersionUpdateInput
    ) {
      updateAdminVersion(uid: $uid, input: $input) {
        code
        success
        message
        admin {
          uid
          first_name
          last_name
          email
          image
          phone_number
        }
      }
    }
  `);
}

@Injectable({
  providedIn: 'root',
})
export class DeleteAdminGQL extends Mutation<DeleteAdminResponse> {
  document = gql(`
    mutation deleteAdmin($uid: ID!) {
      deleteAdmin(uid: $uid) {
        code
        success
        message
      }
    }
  `);
}

export interface InsertAdminMutationResponse {
  code: string;
  success: boolean;
  message: string;
  insertAdmin: {
    admin: Admin;
  };
}

export interface InsertAdminMutationInput {
  uid: string;
  accountUid: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone_number?: string;
  privilege?: number;
  settings?: string;
  breadcrumb?: string;
  image?: string;
  image_key?: string;
  status?: string;
  token?: string;
  last_login?: Date;
}

export interface InsertAdminMutationParams {
  input: InsertAdminMutationInput;
}

@Injectable({
  providedIn: 'root',
})
export class InsertAdminGQL extends Mutation<InsertAdminMutationResponse, InsertAdminMutationParams> {
  document = gql(`
    mutation insertAdmin(
      $input: ModelAdminInsertInput
    ) {
      insertAdmin(input: $input) {
        code
        success
        message
      }
    }
  `);
}

export interface AssignSalespersonMutationResponse {
  code: string;
  success: boolean;
  message: string;
}

export interface AssignSalespersonMutationParams {
  leadUid: string;
  userUid: string;
}

@Injectable({
  providedIn: 'root',
})
export class AssignSalespersonGQL extends Mutation<AssignSalespersonMutationResponse, AssignSalespersonMutationParams> {
  document = gql(`
    mutation assignSalesPerson($userUid: ID!, $leadUid: ID!) {
      assignSalesPerson(uid: $userUid, leadUid: $leadUid) {
        success
      }
    }
  `);
}
